export const INFO = 'info';
export const WARNING = 'warning';
export const ERROR = 'error';
